import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import React, { Component } from 'react';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TimeSelection from './../../../selections/timeSelection/containers/TimeSelection';
import { TIEMPO } from '../../../../constants/icons/gis/gis';
import { Grid } from '@material-ui/core';
import './../../../sig/selections/expands/Styles.css';

class ExpandTime extends Component {

    handleExpanTime = (date) => {
        //console.log("456", date );
        this.props.timeselection(date);
    }

    render() {
        const { Seleccion } = this.props;

        return (
            <Grid container style={{ minWidth: '290px' }}>
                <Grid xs={12} item>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon className="iconColor"/>} >
                            <Grid className="ContExpand">
                                <Grid className="compExpandTitle">
                                { 
                                    Seleccion !== "GIS"
                                    ?<Grid></Grid>
                                    :<Grid>{TIEMPO}</Grid>
                                }
                                </Grid>
                                <Grid className="compExpandTitle">
                                    Selección Tiempo
                                </Grid>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ display: 'list-items' }}>
                            <Grid xs={12} className="ExpandNewSpaceSelection" item>
                                <Grid>
                                    <TimeSelection
                                        year={2024} 
                                        timeselection={this.handleExpanTime}
                                        dataResult={this.props.dataResult}
                                        Seleccion={Seleccion}
                                        timeArray={this.props.timeArray}
                                    />
                                </Grid>
                                {/*   <Grid>
                                    <ApplyFilter/>
                                </Grid>  */}
                            </Grid>

                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Grid>
            </Grid>
        );
    }

}

export default ExpandTime;